export function enableAutoFocusOnKeydown(ref: React.RefObject<HTMLTextAreaElement>) {
  const handleKeyDown = (e: KeyboardEvent) => {
    if (!ref.current) return;

    const activeElement = document.activeElement;
    const isTypingInInput = activeElement && (activeElement.tagName === "INPUT" || activeElement.tagName === "TEXTAREA" || (activeElement as HTMLElement).isContentEditable);
    const isModifierKeyPressed = activeElement && (e.ctrlKey || e.shiftKey || e.altKey || e.metaKey);

    if (isTypingInInput || isModifierKeyPressed) return;
      
    if (document.activeElement !== ref.current) {
      e.preventDefault();
      ref.current.focus();

      const activeElement = document.activeElement;

      if (e.key.length === 1) {
        const start = ref.current.selectionStart || 0;
        const end = ref.current.selectionEnd || 0;
        const value = ref.current.value;

        ref.current.value =
          value.slice(0, start) + e.key + value.slice(end);

        const cursor = start + 1;
        ref.current.selectionStart = cursor;
        ref.current.selectionEnd = cursor;

        ref.current.dispatchEvent(new Event("input", { bubbles: true }));
      }
    }
  };

  window.addEventListener("keydown", handleKeyDown);

  return () => {
    window.removeEventListener("keydown", handleKeyDown);
  };
}


export function resizeTextareaToContent(ref: React.RefObject<HTMLTextAreaElement>) {
  const textarea = ref.current;
  if (!textarea) return;

  textarea.style.height = "revert-layer";
  const maxHeight = 100;
  const newHeight = Math.min(textarea.scrollHeight, maxHeight);

  textarea.style.height = `${newHeight}px`;
  textarea.style.overflowY = textarea.scrollHeight > maxHeight ? "revert-layer" : "hidden";
}

function isMobileDevice(userAgent: string): boolean {
  return /Mobi|Android|iPhone|iPad/i.test(userAgent);
}

export function submitOnEnterDesktop(
  e: React.KeyboardEvent<HTMLTextAreaElement>,
  onSubmit: (...args: any[]) => void
) {
  const isMobile = isMobileDevice(navigator.userAgent);
  if (e.key === "Enter" && !e.shiftKey && !isMobile) {
    e.preventDefault(); // Prevent newline
    onSubmit();
  }
}

export function fixMobileCaretJumpingOnNewLine(e: React.KeyboardEvent<HTMLTextAreaElement>) {
      const isMobile = isMobileDevice(navigator.userAgent);
      if (isMobile && e.key === "Enter"){
        // To fix mobile textarea cursor jump to the left on new line
        let val = e.currentTarget.value;
        e.currentTarget.value = val.replace("\n", "\n\u200F");
        e.currentTarget.value = val.replace("\n\u200F", "\n");
      }
}